import { Component } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-fullscreen-loader',
  standalone: true,
  imports: [MatProgressSpinner],
  templateUrl: './fullscreen-loader.component.html',
  styleUrl: './fullscreen-loader.component.scss'
})
export class FullscreenLoaderComponent {

}
